import { jsxs as s, jsx as o } from "react/jsx-runtime";
import { c as y } from "../clsx-OuTLNxxd.js";
import { B as c } from "../Badge-BvOr_qSw.js";
import { a as h } from "../Tooltip-DVM2gMXz.js";
import "../Comparison.css?__remix_sideEffect__";const f = "320px",m = "600px",p = "1025px",_ = "_isVisuallyHidden_y1fwj_52",B = "_comparisonContainer_y1fwj_64",u = "_valuesContainer_y1fwj_73",w = "_value_y1fwj_73",H = "_label_y1fwj_81",b = "_leftBadge_y1fwj_91",W = "_rightBadge_y1fwj_94",j = "_progressBarContainer_y1fwj_114",C = "_hasMiddleValue_y1fwj_120",S = "_progressBar_y1fwj_114",v = "_leftBar_y1fwj_127",z = "_rightBar_y1fwj_130",$ = "_progress_y1fwj_114",N = "_lowerValue_y1fwj_148",k = "_separatorContainer_y1fwj_152",M = "_separator_y1fwj_152",q = "_middleBadge_y1fwj_165",A = "_separatorWrapper_y1fwj_174",e = {
    mobile: f,
    "mobile-wide": "480px",
    tablet: m,
    "tablet-wide": "800px",
    desktop: p,
    "desktop-mid": "1281px",
    "desktop-large": "1360px",
    "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
    "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
    "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
    "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
    "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
    "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
    "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
    "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
    "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
    "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
    "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
    isVisuallyHidden: _,
    comparisonContainer: B,
    valuesContainer: u,
    value: w,
    label: H,
    leftBadge: b,
    rightBadge: W,
    progressBarContainer: j,
    hasMiddleValue: C,
    progressBar: S,
    leftBar: v,
    rightBar: z,
    progress: $,
    lowerValue: N,
    separatorContainer: k,
    separator: M,
    middleBadge: q,
    separatorWrapper: A
  },D = (a, n = "Comparison") => {
    const t = a.reduce((r, l) => r + l, 0),i = 100;
    return t !== i ? (console.warn(
      `${n} component: The sum of values must equal ${i}. Current sum: ${t}`
    ), !1) : !0;
  },F = ({
    comparisonLabel: a,
    leftValue: n,
    middleValue: t = 0,
    rightValue: i,
    tooltipText: r,
    ...l
  }) => {
    if (!D([n, t, i]))
    return null;
    const x = `${n}%`,d = `${t}%`,g = `${i}%`;
    return /* @__PURE__ */s(
      "div",
      {
        className: e.comparisonContainer,
        role: "region",
        "aria-label": `${a} comparison bar with ${n}% on the left, ${t}% draw in the middle, and ${i}% on the right.`,
        ...l,
        children: [
        /* @__PURE__ */s("div", { className: e.valuesContainer, children: [
          /* @__PURE__ */o("span", { "data-testid": "comparison-left", className: e.value, children: /* @__PURE__ */s(c, { className: e.leftBadge, children: [
              n,
              "%"]
            }) }),
          /* @__PURE__ */s("div", { className: e.label, children: [
            a,
            " ",
            r && /* @__PURE__ */o(h, { children: r })]
          }),
          /* @__PURE__ */o("span", { "data-testid": "comparison-right", className: e.value, children: /* @__PURE__ */s(c, { className: e.rightBadge, children: [
              i,
              "%"]
            }) })]
        }),
        /* @__PURE__ */s(
          "div",
          {
            className: y(e.progressBarContainer, {
              [e.hasMiddleValue]: t > 0
            }),
            children: [
            /* @__PURE__ */o(
              "div",
              {
                className: `${e.progressBar} ${e.leftBar}`,
                style: { width: x }
              }
            ),
            /* @__PURE__ */o(
              "div",
              {
                className: e.separatorContainer,
                style: {
                  width: t ? `${t}%` : void 0
                },
                children: t > 0 && /* @__PURE__ */s(c, { className: e.middleBadge, children: [
                  "DRAW ",
                  d]
                })
              }
            ),
            /* @__PURE__ */o(
              "div",
              {
                className: `${e.progressBar} ${e.rightBar}`,
                style: { width: g }
              }
            )]

          }
        )]

      }
    );
  };
export {
  F as Comparison };